import { submit } from 'redux-form'
import { FIND_SERVICE_HISTORY_FORM } from './constants'

export const submitFindServiceHistoryForm = () => submit(FIND_SERVICE_HISTORY_FORM)
